export default __webpack_public_path__ + "media/images/icon_pin-da7d2fcd7621b8039450ccf96462a1e7.png";